module.exports = __webpack_public_path__ + "static/media/10. Mapeo, Mixta en tela, 140 x 140 cm, 2017 copy.339dbfc8.png";